// для локальной разработки
export const featureToggleOverrides = {
  gameTamagotchiRareBox: false,
  gameTamagotchiPromo8March: false,
  gameTamagotchiBeauties: false,
  gameTamagotchiEnableCountrySelect: false, // включает возможность выбора смены страны на ME
  gameTamagotchiEnableGiftConverter: false,
  gameTamagotchiRedesign: false,
  gameTamagotchiBackToSchool: false,
}
